(function (angular) {
    'use strict';

    angular
        .module('app.sod')
        .controller('app.sod.controller', [
            'util',
            'supportService',
            '$scope',
            '$rootScope',
            '$cookies',
            summaryOfDiscountsController
        ]);

    function summaryOfDiscountsController(util, supportService, $scope, $rootScope, $cookies) {
        $scope.siteContent = siteContent;
        $scope.content = siteContent.site.pages.summaryDiscounts;
        $scope.states = supportService.getStates();
        $scope.states = $scope.states.filter(function (s) {
            return $rootScope.supportedStates.indexOf(s.abbr) >= 0 && util.isStateIncluded(s);
        });
        //required for a disabled option when using ng options (left as an example)
        //$scope.states.push({value:"MA", name:"Massachusetts - Coming Soon", disabled:true });
        $scope.onStateSelected = updateDocumentLinks;
        $scope.openLink = openLink;
        $scope.summaryOfDiscountsUrl = null;
        $scope.feeScheduleUrl = null;

        if (!$scope.content.showStates) {
            $scope.summaryOfDiscountsUrl = eval($scope.content.links.sdf.variableLink);
            $scope.feeScheduleUrl = eval($scope.content.links.fe.variableLink);
        } else if ($rootScope.supportedStates.length <= 1) {
            $scope.summaryOfDiscountsUrl = eval($scope.content.links.sdf.variableLink);
            $scope.feeScheduleUrl = eval($scope.content.links.fe.variableLink);
            updateDocumentLinks($scope.states[0].value);
        }

        var blobUrl = environment.blobStorageTopUrl + '/servicesanddisclosures/';

        if ($cookies.get('stateValue')) {
            var stateValueCookie = $cookies.get('stateValue');
            var stateObject = $scope.states.find(function (state) {
                return state.value === stateValueCookie;
            });

            if (stateObject) {
                updateDocumentLinks(stateValueCookie);
            } else return;
        }

        $scope.$watch('states', function (newVal, oldVal) {
            if (newVal && stateValueCookie) {
                $scope.selectedState = $scope.states.find(function (state) {
                    return state.value === stateValueCookie;
                });
            }
        });

        function updateDocumentLinks(state) {
            $scope.summaryOfDiscountsUrl = eval($scope.content.links.sdf.variableLink).replace('[[STATE]]', state);
            $scope.feeScheduleUrl = eval($scope.content.links.fe.variableLink).replace('[[STATE]]', state);

            var exp = new Date();
            exp.setFullYear(exp.getFullYear() + 100);

            $cookies.put('stateValue', state, { expires: exp });
        }

        function openLink(url) {
            if (!$scope.content.showStates) {
                window.open(url);
            } else {
                if (
                    $rootScope.supportedStates.length <= 1 ||
                    (!$scope.selectStateForm.$invalid &&
                        $scope.selectStateForm.$dirty &&
                        $scope.summaryOfDiscountsUrl !== null &&
                        $scope.feeScheduleUrl !== null)
                ) {
                    window.open(url);
                } else {
                    $scope.selectStateForm.$setDirty();
                }
            }
        }
    }
})(angular);
